"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userSchema = exports.setPhoneInitalized = exports.setAllUserInitalized = exports.setUserInitalized = exports.userFromBackend = exports.profileInitalized = void 0;
const joi_1 = __importDefault(require("joi"));
const joiMessages_1 = require("../data/joiMessages");
const validations_1 = require("../data/validations");
exports.profileInitalized = {
    phone: '',
    allowPhoneLogin: false,
    country: '',
    countryPhoneCode: '',
    firstName: '',
    lastName: '',
    facebookEmail: '',
};
const userFromBackend = (data) => {
    return {
        places: data.places,
        placeUser: data.placeUser,
        email: data.email,
        phone: data.phone,
        allowPhoneLogin: data.allowPhoneLogin,
        country: data.country,
        countryPhoneCode: data.countryPhoneCode,
        phoneConfirmed: data.phoneConfirmed,
        firstName: data.firstName,
        lastName: data.lastName
    };
};
exports.userFromBackend = userFromBackend;
const setUserInitalized = (data) => {
    return {
        phone: data.phone,
        allowPhoneLogin: data.allowPhoneLogin,
        country: data.country,
        countryPhoneCode: data.countryPhoneCode,
        firstName: data.firstName,
        lastName: data.lastName,
        facebookEmail: data.facebookEmail
    };
};
exports.setUserInitalized = setUserInitalized;
const setAllUserInitalized = (data) => {
    return data;
};
exports.setAllUserInitalized = setAllUserInitalized;
const setPhoneInitalized = (data) => {
    return {
        phone: data.phone,
        countryPhoneCode: data.countryPhoneCode,
        phoneConfirmed: data.phoneConfirmed,
    };
};
exports.setPhoneInitalized = setPhoneInitalized;
exports.userSchema = joi_1.default.object({
    phone: joi_1.default.string().pattern(validations_1.numberRegex).optional().allow('').min(4).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Phone', patternText: 'has to be a valid phone number.' }),
    }),
    countryPhoneCode: joi_1.default.string().pattern(validations_1.countryCodeRegex).optional().allow('').max(4).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Country code', patternText: 'has to be on the form "+123".' }),
    }),
    allowPhoneLogin: joi_1.default.boolean(),
    country: joi_1.default.string().optional().allow(''),
    facebookEmail: joi_1.default.string().pattern(validations_1.emailRegex).optional().allow('').max(500).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Facebook email', patternText: 'has to be a email.' }),
    }),
    firstName: joi_1.default.string().pattern(validations_1.alphabetRegex).optional().allow('').max(50).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'First name', patternText: 'has to be a string.' }),
    }),
    lastName: joi_1.default.string().pattern(validations_1.alphabetRegex).optional().allow('').max(50).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Last name', patternText: 'has to be a string.' }),
    }),
});
